'use client'

import { FormEvoFieldMappingModule } from '@repo/formevo-configuration/FormEvoFieldMappingModule'
import MUIStack from '@mui/material/Stack'

export const FieldMappingPanel = () => (
  <MUIStack data-testid="FormEvoFieldMappingPanel">
    <FormEvoFieldMappingModule />
  </MUIStack>
)
